import React from 'react'
import styled from 'styled-components'

import ArrowIcon from 'icons/arrow'
import { formatApartmentName } from 'utils/helper'

export default function MinimizedNavigationPanel({
  activeFloor,
  activeApartment,
  floors,
  changeFloor,
  changeApartInCollapsible,
  onClick,
}) {
  return (
    <Wrapper>
      <ApartmentInfo>
        <ApartmentIcons>
          <ArrowIcon
            rotateDeg="90deg"
            onClick={() => changeApartInCollapsible('previous')}
          />
          <p className="apartment">
            {activeFloor !== 17 && 'Asunto '}
            {formatApartmentName(activeApartment?.label)}
          </p>
          <ArrowIcon
            rotateDeg="-90deg"
            onClick={() => changeApartInCollapsible('next')}
          />
        </ApartmentIcons>

        <ElevatorIcons>
          <ArrowIcon
            rotateDeg="180deg"
            onClick={() => changeFloor('up')}
            disabled={activeFloor === Number(floors[floors.length - 1])}
          />
          <p className="floor">{activeApartment.floor}</p>
          <ArrowIcon
            onClick={() => changeFloor('down')}
            disabled={activeFloor === Number(floors[0])}
          />
          <LogoWrapper>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 963.779 143.031"
            >
              <path
                d="M77.32 56.383c27.57 0 44.567 15.547 44.567 42.91 0 27.362-16.998 43.738-44.567 43.738H5.803v-30.265h71.1c9.33 0 14.097-6.633 14.097-13.473 0-6.841-4.768-13.474-14.096-13.474H44.568C16.998 85.819 0 69.856 0 43.324 0 16.169 16.998 0 44.568 0h67.37v30.265H44.981c-9.328 0-14.096 6.426-14.096 13.059s4.768 13.06 14.096 13.06H77.32zM220.184 0h38.971l-54.932 70.479 54.932 72.552h-40.422l-44.982-59.7v59.7h-33.167V0h33.167v59.907zm133.288 0h-42.08l-50.164 143.03h34.617l9.536-29.227h54.31l9.535 29.228h34.41L353.473 0zM314.71 84.782l17.62-54.31 17.826 54.31H314.71zm192.365 4.561V0h33.166v143.031h-34.41l-56.798-89.55v89.55h-33.166V0h34.41zm130.386-32.96c27.57 0 44.568 15.547 44.568 42.91 0 27.362-16.998 43.738-44.568 43.738h-71.516v-30.265h71.101c9.328 0 14.096-6.633 14.096-13.473 0-6.841-4.768-13.474-14.096-13.474H604.71c-27.57 0-44.568-15.962-44.568-42.495C560.141 16.169 577.14 0 604.71 0h67.37v30.265h-66.955c-9.328 0-14.096 6.426-14.096 13.059s4.768 13.06 14.095 13.06h32.338zM780.327 0h38.971l-54.932 70.479 54.932 72.552h-40.422l-44.982-59.7v59.7h-33.167V0h33.167v59.907zm133.288 0h-42.08l-50.164 143.03h34.617l9.536-29.227h54.31l9.535 29.228h34.41L913.616 0zm-38.763 84.782 17.62-54.31 17.826 54.31h-35.446z"
                fill="#143275"
              />
            </svg>
          </LogoWrapper>
        </ElevatorIcons>

        <OpenButton onClick={onClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M74-184v-136h812v136H74Zm0-228v-136h812v136H74Zm0-229v-136h812v136H74Z" />
          </svg>
        </OpenButton>
      </ApartmentInfo>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 0;

  /* @media (max-width: 575px) {
    width: 95vw;
  } */
`

const ApartmentInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  p {
    margin: 0;
    text-align: center;
    color: #fff;
    user-select: none;
    -webkit-user-select: none;
  }

  .floor {
    min-width: 45px;
    font-size: 1.7rem;
  }

  .apartment {
    min-width: 140px;
    font-size: 1.2rem;
  }

  @media (max-width: 575px) {
    justify-content: flex-end;
    gap: 10px;

    .floor {
      min-width: 35px;
      font-size: 1.2rem;
    }

    .apartment {
      min-width: 105px;
      font-size: 14px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    gap: 7px;

    .floor {
      min-width: 30px;
      font-size: 1rem;
    }

    .apartment {
      min-width: 90px;
      font-size: 12px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    gap: 7px;

    .floor {
      min-width: 35px;
      font-size: 1rem;
    }

    .apartment {
      min-width: 90px;
      font-size: 12px;
    }
  }
`

const ElevatorIcons = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #143275;
  border-radius: 50px;
  border: 3px solid #143275;
`
const ApartmentIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #143275;
  border: 3px solid #143275;
  border-radius: 50px;
`

const OpenButton = styled.button`
  border: 0;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: #143275;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 25px;
    height: 25px;
    margin-left: 5px;
    fill: #ececec;
    transition: fill 0.3s ease;
  }

  &:hover {
    cursor: pointer;

    svg {
      fill: var(--brand-green-color);
    }
  }

  @media (max-width: 575px) {
    width: 34px;
    height: 34px;

    svg {
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 26px;
    height: 26px;

    svg {
      width: 15px;
      height: 15px;
      margin-left: 4px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    width: 26px;
    height: 26px;

    svg {
      width: 15px;
      height: 15px;
      margin-left: 4px;
    }
  }
`

const LogoWrapper = styled.div`
  position: absolute;
  top: -30px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 90px;
  }

  @media (max-width: 575px) {
    top: -25px;

    svg {
      width: 70px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    top: -20px;

    svg {
      width: 55px;
    }
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    top: -20px;

    svg {
      width: 55px;
    }
  }
`
